export default {
      path: '/lvy-privacy-info-list',
      component: () => import('./LVYPrivacyInfoList'),
      meta: {
        title: '《青藤之恋》个人信息收集清单',
        designWidth:750,
        expireIn: 'Thu Dec 31 2099 08:00:00 GMT+0800 (China Standard Time)',
        axiosConfig: {
          baseURL: '',
          withCredentials: false,
          postContentType: 'FormData'
        }
      }
    }
